<template>
    <p-search-input
        :value="value"
        item-text="displayName"
        item-value="id"
        label="Account"
        :callback="callback"
        :get-one-callback="getOneCallback"
        :items="items"
        hide-details="auto"
        :action="action"
        v-bind="$props"
        v-on="$listeners"
        @input="$emit('input', $event)">
    </p-search-input>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PSearchInput from '../common/PSearchInput';
import { searchAccountByNameOrCode as callback, getAccount as getOneCallback } from './../../services/ledger/account';

export default {
    name: "PAccountSearch",
    components: {
        PSearchInput
    },
    props: {
        backgroundColor: String,
        outlined: Boolean,
        value: [String, Number],
        hideDetails: [Boolean, String],
        error: Boolean,
        errorMessages: Array,
        rules: Array
    },
    computed: {
        ...mapState("accounting/account", {
            items: (state) => state.accountsLookup
        })
    },
    methods: {
        ...mapActions("accounting/account", {
            action: 'setAccountsLookup'
        }),
        callback,
        getOneCallback
    }
}
</script>